(() => {
  const configNode = document.querySelector('[data-leavys-search-config]');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const text = config.text;
  const DEPARTMENT = 'filter.v.t.shopify.target-gender';
  const departmentValues = config.departments;
  const selectedDepartments = url => Object.keys(departmentValues).filter(key=>url.searchParams.getAll(DEPARTMENT).includes(departmentValues[key]));
  const SIZE = 'filter.v.option.size';
  const WIDTH = 'filter.v.t.shopify.shoe-fit';
  const COLOUR = 'filter.v.t.shopify.color-pattern';
  const VENDOR = 'filter.p.vendor';
  const norm = value => String(value || '').normalize('NFKC').toLowerCase().replace(/[’‘]/g, "'").trim();
  const escapePattern = value => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const styles = [
    {id:'ankle_boots', pattern:/\b(?:ankle|chelsea)\s+boots?\b/i, query:'(tag:"Ankle Boots" OR (title:boot AND title:ankle))'},
    {id:'knee_boots', pattern:/\b(?:knee[ -]high|long|tall)\s+boots?\b/i, query:'(tag:"Long Boots" OR title:"knee high" OR title:"knee-high" OR title:"long boot" OR title:"tall boot")'},
    {id:'mary_janes', pattern:/\bmary[ -]?janes?\b/i, query:'(title:"mary jane" OR title:"mary-jane" OR title:maryjane)'},
    {id:'trainers', pattern:/\b(?:trainers?|sneakers?|runners?)\b/i, query:'(tag:Runners OR tag:"Mens Runners" OR title:trainer OR title:sneaker OR title:runner)'},
    {id:'boots', pattern:/\bboots?\b/i, query:'(tag:"Ankle Boots" OR tag:"Long Boots" OR tag:"Mens Boots" OR title:boot)'},
    {id:'loafers', pattern:/\bloafers?\b/i, query:'title:loafer'},
    {id:'brogues', pattern:/\bbrogues?\b/i, query:'title:brogue'},
    {id:'sandals', pattern:/\bsandals?\b/i, query:'(tag:"Summer Sandals" OR tag:"mens sandals" OR title:sandal)'},
    {id:'slippers', pattern:/\bslippers?\b/i, query:'(tag:Slippers OR title:slipper)'},
    {id:'heels', pattern:/\b(?:heels?|court\s+shoes?)\b/i, query:'(tag:Heels OR title:court OR (title:heel -title:boot))'}
  ];
  const colours = Object.entries(config.colours).sort((a,b)=>b[0].length-a[0].length);
  const vendors = config.vendors.slice().sort((a,b)=>b.length-a.length);
  function interpret(raw, scope) {
    const input = String(raw || '').trim().slice(0,180);
    let rest = norm(input);
    const filters = new Map();
    const departments = [];
    const women = /\b(?:women(?:'s|s)?|woman(?:'s|s)?|ladies|lady)\b/g;
    const men = /\b(?:men(?:'s|s)?|man(?:'s|s)?|gents|gentlemen)\b/g;
    if (women.test(rest)) departments.push('Womens');
    if (men.test(rest)) departments.push('Mens');
    if (/\bunisex\b/.test(rest)) departments.push('Unisex');
    rest = rest.replace(women,' ').replace(men,' ').replace(/\bunisex\b/g,' ');
    const selected = scope === undefined ? departments : scope ? [scope] : [];
    if (selected.length) filters.set(DEPARTMENT,selected.map(key=>departmentValues[key]).filter(Boolean));
    const help = config.help.find(item=>new RegExp(item.pattern,'i').test(norm(input)));
    let style;
    if (!/(?:^|\s)(?:title|body|tag|vendor|product_type|variants\.[a-z]+):/.test(rest)) {
      const foundVendors = [];
      for (const vendor of vendors) {
        const pattern = new RegExp('\\b'+escapePattern(norm(vendor))+'\\b','i');
        if (pattern.test(rest)) {foundVendors.push(vendor);rest=rest.replace(pattern,' ');}
      }
      if (foundVendors.length) filters.set(VENDOR,foundVendors);
      const width = rest.match(/\b(wide|narrow|regular)(?:[ -]fit(?:ting)?)?\b/i);
      if (width && !/\bextra[ -]wide\b/.test(rest) && !/\b(?:not|no|without)\s+(?:a\s+)?(?:wide|narrow|regular)\b/.test(rest)) {
        filters.set(WIDTH,[config.widths[width[1].toLowerCase()]]);
        rest=rest.replace(width[0],' ');
      }
      const sizeMatch = rest.match(/\b(?:sizes?|eu|uk)\s*((?:(?:eu|uk)\s*)?\d{1,2}(?:\.5)?(?:\s*(?:,|\/|&|and|or)\s*(?:(?:eu|uk)\s*)?\d{1,2}(?:\.5)?)*)\b/i);
      if (sizeMatch) {
        const sizes = sizeMatch[1].match(/\d{1,2}(?:\.5)?/g) || [];
        const valid = sizes.every(size=>config.sizes.includes(size));
        const systemValid = !/^eu\b/i.test(sizeMatch[0]) || sizes.every(size=>Number(size)>=30);
        const ukValid = !/^uk\b/i.test(sizeMatch[0]) || sizes.every(size=>Number(size)<20);
        if (valid && systemValid && ukValid) {filters.set(SIZE,[...new Set(sizes)]);rest=rest.replace(sizeMatch[0],' ');}
      }
      const foundColours = [];
      for (const [label,value] of colours) {
        const pattern = new RegExp('\\b'+escapePattern(label)+'\\b','i');
        if (pattern.test(rest)) {foundColours.push(value);rest=rest.replace(pattern,' ');}
      }
      if (foundColours.length) filters.set(COLOUR,[...new Set(foundColours)]);
      style = styles.find(item=>item.pattern.test(rest));
      if (style) {
        const matched = rest.match(style.pattern)[0];
        rest = rest.replace(style.pattern,' ');
        style = {...style};
        if (style.id === 'ankle_boots' && matched.startsWith('chelsea')) style.query = 'title:boot AND title:chelsea';
      }
      rest = rest.replace(/\b(?:shoes?|footwear|for|in|the|a|and|or)\b/g,' ').replace(/\s+/g,' ').trim();
      // A size on its own after a recognised style/brand is intent, not a model code.
      if (!filters.has(SIZE) && (style || filters.has(VENDOR) || filters.has(WIDTH) || /\b(?:shoes?|footwear)\b/.test(norm(input))) && /^\d{1,2}(?:\.5)?$/.test(rest) && config.sizes.includes(rest)) {
        filters.set(SIZE,[rest]);rest='';
      }
    }
    let query = rest || '*';
    if (style) query = rest ? `(${style.query}) AND (${rest})` : style.query;
    return {raw:input,query,rest,filters,style,help,departments:selected};
  }
  function buildUrl(raw, scope) {
    const intent = interpret(raw,scope);
    const url = new URL(config.searchUrl,location.origin);
    url.searchParams.set('q',intent.query);
    url.searchParams.set('type','product');
    url.searchParams.set('filter.v.availability','1');
    url.searchParams.set('options[prefix]','last');
    url.searchParams.set('ls','1');
    url.searchParams.set('lsq',intent.raw);
    if (config.preview) url.searchParams.set('preview_theme_id',config.themeId);
    if (intent.style) url.searchParams.set('ls_style',intent.style.id);
    for (const [key,values] of intent.filters) for (const value of values) url.searchParams.append(key,value);
    return url;
  }
  function resolve(destination) {
    const url = new URL(destination,location.href);
    if (url.pathname.includes('/collections/') || url.pathname === config.searchUrl) {
      const legacyKeys=[...new Set([...url.searchParams.keys()].filter(key=>key.startsWith('gf_')))];
      for (const key of legacyKeys) {
        for (const value of url.searchParams.getAll(key)) {
          const mapping=config.legacyFilters?.[key];
          let param=mapping?.param, translated=mapping?.values[norm(value)];
          if (key==='gf_732579' && config.sizes.includes(value)) {param=SIZE;translated=value;}
          if (key==='gf_692426' && config.vendors.includes(value)) {param=VENDOR;translated=value;}
          if (url.pathname===config.searchUrl && param==='filter.p.tag') translated=undefined;
          if (param && translated) {
            if (!url.searchParams.getAll(param).includes(translated)) url.searchParams.append(param,translated);
          } else url.searchParams.set('ls_legacy_notice','1');
        }
        url.searchParams.delete(key);
      }
      // Keep saved links working after separating taxonomy colour families into shades.
      const oldColours = url.searchParams.getAll(COLOUR);
      if (oldColours.some(value=>value.split(',').some(id=>config.legacyColourValues?.[id]))) {
        const nextColours = oldColours.flatMap(value=>value.split(',').flatMap(id=>config.legacyColourValues?.[id] || [id]));
        url.searchParams.delete(COLOUR);
        [...new Set(nextColours)].forEach(value=>url.searchParams.append(COLOUR,value));
      }
    }
    const legacy = url.searchParams.getAll('filter.p.product_type');
    if (legacy.length && legacy.every(value=>departmentValues[value])) {
      if (!url.searchParams.has(DEPARTMENT)) legacy.forEach(value=>url.searchParams.append(DEPARTMENT,departmentValues[value]));
      url.searchParams.delete('filter.p.product_type');
    }
    if (url.pathname !== config.searchUrl || url.searchParams.get('ls') === '1' || !url.searchParams.get('q') || (url.searchParams.has('type') && url.searchParams.get('type') !== 'product')) return url;
    const next = buildUrl(url.searchParams.get('q'));
    const keys = new Set([...url.searchParams.keys()].filter(k=>k!=='q'));
    for (const key of keys) {
      next.searchParams.delete(key);
      url.searchParams.getAll(key).forEach(value=>next.searchParams.append(key,value));
    }
    return next;
  }
  const api = {interpret,buildUrl,resolve};
  window.LeavysSearch = api;
  const states = new WeakMap();
  const cache = new Map();
  let serial = 0;
  function setScope(form, scope) {
    const value = departmentValues[scope] || '';
    form.querySelectorAll('[data-ls-scope]').forEach(control=>{
      if (control.type === 'radio') control.checked = control.value === value;
      else control.value = value;
    });
    // Old Unisex-only URLs still work, without inaccurately marking All as selected.
    form.dataset.lsScope = scope || '';
  }
  function close(form, cancel = true) {
    const state = states.get(form);
    if (!state) return;
    clearTimeout(state.timer);
    if (cancel) {state.controller?.abort();state.serial++;}
    state.panel.hidden = true;
    state.input.setAttribute('aria-expanded','false');
    state.panel.removeAttribute('aria-busy');
  }
  function element(tag, label, className) {
    const node = document.createElement(tag);
    if (label) node.textContent=label;
    if (className) node.className=className;
    return node;
  }
  function addLink(parent,label,url,className) {
    const link=element('a',label,className);link.href=url;parent.append(link);return link;
  }
  function displayTerm() {
    const url = new URL(location.href);
    return url.searchParams.get('lsq') || (url.searchParams.get('q') === '*' ? '' : url.searchParams.get('q') || '');
  }
  function intentFor(form) {
    const state=states.get(form);
    return interpret(state.input.value,state.manualScope);
  }
  function urlFor(form) {
    const state=states.get(form);
    return buildUrl(state.input.value,state.manualScope);
  }
  function preparePanel(form, intent, url) {
    const state=states.get(form);
    state.panel.replaceChildren();
    const top=element('div',null,'ls-panel-top');
    top.append(element('strong',text.suggestions));
    const dismiss=element('button',text.close,'ls-dismiss');dismiss.type='button';dismiss.dataset.lsDismiss='';top.append(dismiss);
    state.panel.append(top);
    if (intent.help) addLink(state.panel,intent.help.label,intent.help.url,'ls-help-link');
    if (!intent.style && !intent.rest && intent.filters.get(VENDOR)?.length===1) {
      const brand=intent.filters.get(VENDOR)[0];
      const browse=new URL('/collections/all',location.origin);
      browse.searchParams.set(VENDOR,brand);browse.searchParams.set('sort_by','created-descending');browse.searchParams.set('filter.v.availability','1');
      for (const [key,values] of intent.filters) if (key!==VENDOR) values.forEach(value=>browse.searchParams.append(key,value));
      addLink(state.panel,text.shop_brand.replace('__BRAND__',()=>brand),browse.href,'ls-help-link');
    }
    if (!intent.departments.length && intent.style) {
      const scopes=element('div',null,'ls-scope-links');
      for (const department of ['Womens','Mens']) addLink(scopes,`${text[department]} · ${text.styles[intent.style.id]}`,buildUrl(intent.raw,department).href);
      state.panel.append(scopes);
    }
    const list=element('div',null,'ls-product-suggestions');list.dataset.lsProducts='';state.panel.append(list);
    addLink(state.panel,text.all_results,url.href,'ls-all-results');
    state.panel.hidden=false;
    state.input.setAttribute('aria-expanded','true');
    setScope(form,intent.departments.length===1?intent.departments[0]:'');
    return list;
  }
  async function suggest(form) {
    const state=states.get(form);
    state.controller?.abort();
    const request=++state.serial;
    const intent=intentFor(form);
    if (intent.raw.length<2) {close(form);return;}
    const url=urlFor(form);
    const list=preparePanel(form,intent,url);
    if (intent.help) return;
    state.panel.setAttribute('aria-busy','true');
    list.append(element('p',text.loading,'ls-feedback'));
    const endpoint=new URL(url);endpoint.searchParams.set('section_id','leavys-search-suggestions');
    endpoint.searchParams.delete('lsq');endpoint.searchParams.delete('ls_style');endpoint.searchParams.delete('ls');
    endpoint.searchParams.delete('preview_theme_id');
    state.controller=new AbortController();
    const started=performance.now();
    try {
      if (window.LeavysSearchRanking) {
        const nodes=await window.LeavysSearchRanking.suggestions(url,state.controller.signal,String(config.themeId));
        if (request!==state.serial || !form.isConnected) return;
        list.replaceChildren(...nodes);
      } else {
      let entry=cache.get(endpoint.href);
      if (!entry || Date.now()-entry.time>30000) {
        const response=await fetch(endpoint,{signal:state.controller.signal,credentials:'same-origin'});
        if (!response.ok) throw Error('Search unavailable');
        const html=await response.text();
        entry={html,time:Date.now()};
        cache.set(endpoint.href,entry);
        if (cache.size>20) cache.delete(cache.keys().next().value);
      }
      if (request!==state.serial || !form.isConnected) return;
      const doc=new DOMParser().parseFromString(entry.html,'text/html');
      const result=doc.querySelector('[data-ls-suggestion-results]');
      if (!result || result.dataset.theme!==String(config.themeId)) throw Error('Search preview changed');
      list.replaceChildren(...result.children);
      }
      state.panel.removeAttribute('aria-busy');
      state.panel.dataset.responseMs=String(Math.round(performance.now()-started));
      if (!list.querySelector('a')) list.append(element('p',text.no_suggestions,'ls-feedback'));
    } catch(error) {
      if (error.name==='AbortError' || request!==state.serial) return;
      list.replaceChildren(element('p',text.continue_search,'ls-feedback'));
      state.panel.removeAttribute('aria-busy');
    }
  }
  function initForms() {
    document.querySelectorAll('[data-ls-form]').forEach(form=>{
      if (states.has(form)) return;
      const input=form.querySelector('[data-search-input]');
      const panel=form.querySelector('[data-ls-panel]');
      if (!input || !panel) return;
      panel.id=`LeavysSearchSuggestions-${++serial}`;
      input.setAttribute('aria-controls',panel.id);
      input.setAttribute('aria-expanded','false');
      input.setAttribute('aria-autocomplete','list');
      panel.setAttribute('aria-label',text.suggestions);
      const departments=selectedDepartments(new URL(location.href));
      const pageDepartment = ['Womens','Mens'].includes(form.dataset.lsDepartment) ? form.dataset.lsDepartment : undefined;
      const initialScope = departments.length===1 ? departments[0] : departments.length ? undefined : pageDepartment;
      const state={input,panel,serial:0,manualScope:initialScope};
      states.set(form,state);
      if (location.pathname===config.searchUrl) input.value=displayTerm();
      setScope(form,state.manualScope);
      form.querySelector('[data-ls-clear]').hidden=!input.value;
    });
  }
  function decorate() {
    initForms();
    const url=new URL(location.href);
    const root=document.querySelector('leavys-results');
    if (!root) return;
    root.querySelector('[data-ls-legacy-notice]')?.remove();
    if (url.searchParams.has('ls_legacy_notice')) {
      const notice=element('p',text.legacy_notice,'ls-legacy-notice');
      notice.dataset.lsLegacyNotice='';notice.setAttribute('role','status');
      root.prepend(notice);
    }
    if (url.pathname!==config.searchUrl) return;
    const departments=selectedDepartments(url);
    document.querySelectorAll('[data-ls-form]').forEach(searchForm=>{
      const state=states.get(searchForm);
      if (state && !searchForm.contains(document.activeElement)) {
        state.manualScope=departments.length===1?departments[0]:undefined;
        state.input.value=displayTerm();
        setScope(searchForm,state.manualScope);
      }
    });
    const heading=root.querySelector('[data-ls-title]');
    if (heading) {
      heading.textContent=displayTerm()?text.results_for.replace(/__QUERY__|\{\{ query \}\}/,()=>displayTerm()):text.search_title;
      document.title=heading.textContent+' — '+config.shopName;
    }
    const form=root.querySelector('[data-nf-form]');
    const queryField=form?.querySelector('input[name="q"]');
    if (queryField) queryField.value=url.searchParams.get('q') || '*';
    const clearFilters=root.querySelector('.nf-apply a[data-nf-link]');
    if (clearFilters) {
      const clear=new URL(clearFilters.href,location.origin);
      clear.searchParams.set('q',url.searchParams.get('q') || '*');
      clear.searchParams.set('filter.v.availability','1');
      for (const key of ['ls','lsq','ls_style']) if (url.searchParams.has(key)) clear.searchParams.set(key,url.searchParams.get(key));
      const searchStyle=styles.find(item=>item.id===url.searchParams.get('ls_style'));
      const clearedTerm=searchStyle?[interpret(displayTerm()).rest,text.styles[searchStyle.id]].filter(Boolean).join(' '):(url.searchParams.get('q')==='*'?'':url.searchParams.get('q') || '');
      clear.searchParams.set('lsq',clearedTerm);
      clearFilters.href=clear.href;
    }
    if (form) for (const key of ['ls','lsq','ls_style']) {
      form.querySelectorAll(`input[name="${key}"]`).forEach(n=>n.remove());
      if (url.searchParams.has(key)) {const field=document.createElement('input');field.type='hidden';field.name=key;field.value=url.searchParams.get(key);form.append(field);}
    }
    root.querySelector('[data-ls-style-chip]')?.remove();
    const style=styles.find(s=>s.id===url.searchParams.get('ls_style'));
    const filterButton=root.querySelector('[data-nf-filter-count]');
    if (filterButton) {
      const count=Number(filterButton.dataset.nfFilterCount)+(style?1:0);
      filterButton.textContent=filterButton.dataset.nfFilterLabel+(count?` (${count})`:'');
    }
    const styleChoices=root.querySelector('[data-ls-style-choices]');
    if (styleChoices) {
      styleChoices.replaceChildren();
      for (const choice of styles) {
        const target=new URL(url);
        const remaining=interpret(displayTerm()).rest;
        target.searchParams.set('q',remaining?`(${choice.query}) AND (${remaining})`:choice.query);
        target.searchParams.set('ls_style',choice.id);
        const nextTerm=style?displayTerm().replace(style.pattern,text.styles[choice.id]):`${displayTerm()} ${text.styles[choice.id]}`.trim();
        target.searchParams.set('lsq',nextTerm);
        target.searchParams.set('ls','1');target.searchParams.delete('page');
        const link=addLink(styleChoices,text.styles[choice.id],target.href);
        link.dataset.nfLink='';
        if (choice.id===style?.id) link.setAttribute('aria-current','true');
      }
    }
    if (style) {
      const clear=new URL(url);
      clear.searchParams.set('q',interpret(displayTerm()).rest || '*');
      clear.searchParams.delete('ls_style');clear.searchParams.delete('page');
      const chip=addLink(root.querySelector('.nf-active'),`${text.style}: ${text.styles[style.id]} ×`,clear.href);
      chip.dataset.nfLink='';chip.dataset.lsStyleChip='';chip.setAttribute('aria-label',`${text.remove} ${text.styles[style.id]}`);
    }
    const empty=root.querySelector('[data-ls-recovery]');
    if (empty) {
      empty.replaceChildren();
      const help=interpret(displayTerm()).help;
      if (help) addLink(empty,help.label,help.url,'ls-recovery-link');
      if (style) {
        const broader=new URL(url);
        broader.searchParams.set('q',`${interpret(displayTerm()).rest} ${text.styles[style.id]}`.trim());
        broader.searchParams.delete('ls_style');broader.searchParams.delete('page');
        const link=addLink(empty,text.broader_search,broader.href,'ls-recovery-link');link.dataset.nfLink='';
      }
      for (const [key,label] of [[COLOUR,text.other_colours],[VENDOR,text.other_brands],[WIDTH,text.other_widths]]) {
        if (!url.searchParams.has(key)) continue;
        const alternative=new URL(url);alternative.searchParams.delete(key);alternative.searchParams.delete('page');
        const link=addLink(empty,label,alternative.href,'ls-recovery-link');link.dataset.nfLink='';
      }
      const department=selectedDepartments(url)[0];
      for (const choice of department?[department]:['Womens','Mens']) {
        const browse=new URL(choice==='Mens'?config.menUrl:config.womenUrl,location.origin);
        browse.searchParams.set('filter.v.availability','1');
        for (const size of url.searchParams.getAll(SIZE)) browse.searchParams.append(SIZE,size);
        addLink(empty,choice==='Mens'?text.browse_men:text.browse_women,browse.href,'ls-recovery-link');
      }
    }
  }
  document.addEventListener('input',event=>{
    const form=event.target.closest('[data-ls-form]');
    if (!form || !event.target.matches('[data-search-input]')) return;
    const state=states.get(form);
    if (!state) return;
    const inferred=interpret(state.input.value).departments;
    if (inferred.length) state.manualScope=undefined;
    state.controller?.abort();state.serial++;
    clearTimeout(state.timer);
    close(form,false);
    form.querySelector('[data-ls-clear]').hidden=!state.input.value;
    const intent=intentFor(form);setScope(form,intent.departments.length===1?intent.departments[0]:'');
    state.timer=setTimeout(()=>suggest(form),280);
  });
  document.addEventListener('focusin',event=>{
    const form=event.target.closest('[data-ls-form]');
    if (form && event.target.matches('[data-search-input]') && states.get(form)?.input.value.trim().length>=2) suggest(form);
  });
  document.addEventListener('change',event=>{
    if (!event.target.matches('[data-ls-scope]')) return;
    const form=event.target.closest('[data-ls-form]');
    const state=states.get(form);
    if (!state || (event.target.type==='radio' && !event.target.checked)) return;
    const scope=Object.keys(departmentValues).find(key=>departmentValues[key]===event.target.value) || '';
    document.querySelectorAll('[data-ls-form]').forEach(other=>{
      const otherState=states.get(other);
      if (!otherState) return;
      otherState.manualScope=scope;
      close(other);
      setScope(other,scope);
    });
    if (state.input.value.trim()) suggest(form);
  });
  document.addEventListener('submit',event=>{
    const form=event.target.closest('[data-ls-form]');
    if (!form) return;
    event.preventDefault();
    const state=states.get(form);
    if (!state.input.value.trim()) {state.input.focus();return;}
    const intent=intentFor(form);
    close(form);
    location.assign(intent.help?.url || urlFor(form).href);
  });
  document.addEventListener('click',event=>{
    document.querySelectorAll('[data-ls-form]').forEach(form=>{if (!form.contains(event.target)) close(form);});
    const form=event.target.closest('[data-ls-form]');
    if (!form) return;
    const state=states.get(form);
    if (event.target.closest('[data-ls-clear]')) {state.input.value='';close(form);form.querySelector('[data-ls-clear]').hidden=true;state.input.focus();}
    if (event.target.closest('[data-ls-dismiss]')) {close(form);state.input.focus();close(form);}
  });
  document.addEventListener('keydown',event=>{
    const form=event.target.closest('[data-ls-form]');
    if (!form) return;
    const state=states.get(form);
    if (event.key==='Escape') {event.stopPropagation();close(form);state.input.focus();close(form);}
    if (state.panel.hidden || !['ArrowDown','ArrowUp'].includes(event.key)) return;
    const links=[...state.panel.querySelectorAll('a')];
    if (!links.length) return;
    event.preventDefault();
    const current=links.indexOf(document.activeElement);
    const next=event.key==='ArrowDown'?(current+1)%links.length:(current<=0?links.length-1:current-1);
    links[next].focus();
  });
  document.addEventListener('focusout',event=>{
    const form=event.target.closest('[data-ls-form]');
    if (form && event.relatedTarget && !form.contains(event.relatedTarget)) close(form);
  });
  document.addEventListener('leavys:filters-rendered',decorate);
  document.addEventListener('shopify:section:load',initForms);
  decorate();
})();
